import { defineStore } from "pinia";
import providusService from "../../service/providus/providus.service";


interface State {}
const providusStore = defineStore("providus", {
  state: (): State => ({}),
  actions: {
    async getBankss(): Promise<any> {
          try {
            const response = await providusService.getBanks();
            if (response.data) {
              return await Promise.resolve(response);
            } else if (response.response) {
              return await Promise.reject(response.response);
            } else {
              return await Promise.reject(response.message);
            }
          } catch (error: any) {
            return await Promise.reject(error);
          }
        },

        async getBanks(): Promise<any> {
          try {
            const response = await providusService.getBanks();
            if (response.data && response.data.data) {
              return await Promise.resolve(response);
            } else if (response.response) {
              return await Promise.reject(response.response);
            } else {
              return await Promise.reject(response.message);
            }
          } catch (error: any) {
            return await Promise.reject(error);
          }
        },

        async verifyAccountt(accountNumber: string, bankCode: string): Promise<any> {
            try {
              const response = await providusService.verifyAccount(accountNumber, bankCode);
              if (response.data) {
                return await Promise.resolve(response);
              } else if (response.response) {
                return await Promise.reject(response.response);
              } else {
                return await Promise.reject(response.message);
              }
            } catch (error: any) {
              return await Promise.reject(error);
            }
          },

          async verifyAccount(accountNumber: string, bankCode: string): Promise<any> {
            try {
              const response = await providusService.verifyAccount(accountNumber, bankCode);
              if (response.data) {
                return await Promise.resolve(response);
              } else if (response.response) {
                return await Promise.reject(response.response);
              } else {
                return await Promise.reject(response.message);
              }
            } catch (error: any) {
              return await Promise.reject(error);
            }
          }

  },
});

export default providusStore;
